/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityProcesses
 */
export interface ControlEntityProcesses {
    /**
     * 
     * @type {number}
     * @memberof ControlEntityProcesses
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityProcesses
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityProcesses
     */
    count?: number;
    /**
     * 
     * @type {Array<any>}
     * @memberof ControlEntityProcesses
     */
    results: Array<any>;
}

/**
 * Check if a given object implements the ControlEntityProcesses interface.
 */
export function instanceOfControlEntityProcesses(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlEntityProcessesFromJSON(json: any): ControlEntityProcesses {
    return ControlEntityProcessesFromJSONTyped(json, false);
}

export function ControlEntityProcessesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityProcesses {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': json['results'],
    };
}

export function ControlEntityProcessesToJSON(value?: ControlEntityProcesses | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results,
    };
}

